import { useQuery } from '@tanstack/react-query';

import { hookEnabledError } from '@hcs/utils';

import { AuthzApi } from '../api';

export const QUERY_KEY_CAPABILITIES_FOR_USER =
  'QUERY_KEY_CAPABILITIES_FOR_USER';

const STALE_TIME = 15 * 60 * 1000; // 15 minutes
export const useCapabilitiesForUser = (userId: number | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEY_CAPABILITIES_FOR_USER, userId],

    queryFn: async () => {
      if (!userId) {
        throw hookEnabledError('useCapabilitiesForUser', 'userId');
      }
      const response = await AuthzApi.getCapabilitiesForUser(userId);
      return response.capabilities;
    },
    staleTime: STALE_TIME,
    enabled: !!userId,
  });
};
